import { array, string, type } from "superstruct";

import { DiscountCodesSchema } from "../api_services/AjaxApiCartApiService/schemas/DiscountCodesSchema";
import { CartItemSchema } from "./CartItemSchema";

export const CartSchema = type({
    token: string(),
    items: array(CartItemSchema),
    discount_codes: array(DiscountCodesSchema),
});
